import { User } from './types';
import { createAsyncAction } from 'typesafe-actions';
import { FailureActionPayload } from 'store/errors/types';

export const getCurrentUser = createAsyncAction(
  'user/GET_CURRENT_REQUEST',
  'user/GET_CURRENT_RESPONSE',
  'user/GET_CURRENT_FAILURE',
)<void, User, FailureActionPayload>();
